<template>
  <section style="height: 100%" class="d-flex align-center">
    <v-container>
      <v-row class="d-flex justify-center">
        <v-col cols="11" md="5" class="pa-0">
          <v-card class="pa-3">
            <div class="d-flex flex-wrap">
              <v-sheet class="pa-7 mt-n7 primary text-center box-shadow" dark width="100%">503 Maintenance mode</v-sheet>
            </div>
            <v-card-text>
              Service is currently in maintenance mode. Give us few minutes. Thanks!
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
    export default {

    }
</script>